import {NICEDisposition} from './NICE_Disposition.model';

export class NICESkill
{
    skillId: number;
    skillName: string;
    mediaTypeId: number;
    mediaTypeName: string;
    mediaTypeIcon: string;
    isActive: boolean;
    campaignId: number;
    campaignName: string;
    notes: string;
    acwTypeId: number;
    stateIdACW: number;
    stateNameACW: string;
    maxSecondsACW: number;
    acwPostTimeoutStateId: number;
    acwPostTimeoutStateName: string;
    requireDisposition: boolean;
    allowSecondaryDisposition: boolean;
    scriptDisposition: string;
    agentRestTime: number;
    makeTranscriptAvailable: boolean;
    transcriptFromAddress: string;
    displayThankyou: boolean;
    thankYouLink: string;
    popThankYou: boolean;
    popThankYouURL: string;
    isOutbound: boolean;
    outboundStrategy: string;
    isRunning: boolean;
    priorityBlending: boolean;
    callerIdOverride: string;
    scriptId: number;
    scriptName = '';
    emailFromAddress: string;
    emailFromEditable: boolean;
    emailBccAddress: string;
    emailParking: boolean;
    chatWarningThreshold: number;
    agentTypingIndicator: boolean;
    patronTypingPreview: boolean;
    interruptible: boolean;
    callSuppressionScriptId: number;
    callSuppressionScriptName: string;
    reskillHours: number;
    reskillHoursName: string;
    countReskillHours: boolean;
    minWFIAgents: number;
    minWFIAvailableAgents: number;
    useScreenPops: boolean;
    screenPopTriggerEvent: number;
    useCustomScreenPops: boolean;
    screenPopDetail: string;
    minWorkingTime: number;
    agentless: boolean;
    agentlessPorts: number;
    initialPriority: number;
    acceleration: number;
    maxPriority: number;
    serviceLevelThreshold: number;
    serviceLevelGoal: number;
    enableShortAbandon: boolean;
    shortAbandonThreshold: number;
    countShortAbandons: boolean;
    countOtherAbandons: boolean;
    messageTemplateId: number;
    smsTransportCodeId: number;
    smsTransportCode: string;
    dispositions: NICEDisposition [];
    deliverMultipleNumbersSerially: boolean;
    cradleToGrave: boolean;
    priorityInterrupt: false;
    customMediaTypeName: string;
    // contactsOffered = 0;
    // contactsHandled = 0;
    // contactsHandledPercent = 0;
    requireManualAccept: boolean;
    presentAcceptReject: boolean;
    agentResponseEnabled: boolean;
    agentFirstResponseTime: number;
    agentFollowOnResponseTime: number;
    customerResponseEnabled: boolean;
    customerIdleTime: number;
    timeExtensionEnabled: boolean;
    evaluationCriteria: number;
    focusMetric: any;
    equityLevel: any;
    focusLock: any;
    fallbackTime: number;
    agentlessDeliveryDelaySeconds: number;

    constructor(niceSkill?)
    {
        if (niceSkill != null) {
            this.skillId = niceSkill.skillId;
            this.skillName = niceSkill.skillName;
            this.mediaTypeId = niceSkill.mediaTypeId;
            this.mediaTypeName = niceSkill.mediaTypeName;
            this.isActive = niceSkill.isActive;
            this.campaignId = +niceSkill.campaignId;
            this.campaignName = niceSkill.campaignName;
            this.notes = niceSkill.notes;
            this.acwTypeId = +niceSkill.acwTypeId;
            this.stateIdACW = niceSkill.stateIdACW;
            this.stateNameACW = niceSkill.stateNameACW;
            this.maxSecondsACW = +niceSkill.maxSecondsACW;
            this.acwPostTimeoutStateId = +niceSkill.acwPostTimeoutStateId;
            this.acwPostTimeoutStateName = niceSkill.acwPostTimeoutStateName;
            this.requireDisposition = niceSkill.requireDisposition;
            this.allowSecondaryDisposition = niceSkill.allowSecondaryDisposition;
            this.scriptDisposition = niceSkill.scriptDisposition;
            this.agentRestTime = +niceSkill.agentRestTime;
            this.makeTranscriptAvailable = niceSkill.makeTranscriptAvailable;
            this.transcriptFromAddress = niceSkill.transcriptFromAddress;
            this.displayThankyou = niceSkill.displayThankyou;
            this.thankYouLink = niceSkill.thankYouLink;
            this.popThankYou = niceSkill.popThankYou;
            this.popThankYouURL = niceSkill.popThankYouURL;
            this.isOutbound = niceSkill.isOutbound;
            this.outboundStrategy = niceSkill.outboundStrategy;
            this.isRunning = niceSkill.isRunning;
            this.priorityBlending = niceSkill.priorityBlending;
            this.callerIdOverride = niceSkill.callerIdOverride;
            this.scriptId = +niceSkill.scriptId;
            this.scriptName = niceSkill.scriptName;
            if (niceSkill.emailFromAddress)
            {
                this.emailFromAddress = niceSkill.emailFromAddress;
            }
            else
            {
                this.emailFromAddress = null;
            }
            this.emailFromEditable = niceSkill.emailFromEditable;
            this.emailBccAddress = niceSkill.emailBccAddress;
            this.emailParking = niceSkill.emailParking;
            this.chatWarningThreshold = +niceSkill.chatWarningThreshold;
            this.agentTypingIndicator = niceSkill.agentTypingIndicator;
            this.patronTypingPreview = niceSkill.patronTypingPreview;
            this.interruptible = niceSkill.interruptible;
            this.callSuppressionScriptId = +niceSkill.callSuppressionScriptId;
            this.reskillHours = +niceSkill.reskillHours;
            this.reskillHoursName = niceSkill.reskillHoursName;
            this.countReskillHours = niceSkill.countReskillHours;
            this.minWFIAgents = niceSkill.minWFIAgents;
            this.minWFIAvailableAgents = niceSkill.minWFIAvailableAgents;
            this.useScreenPops = niceSkill.useScreenPops;
            if (niceSkill.screenPopTriggerEvent)
            {
                this.screenPopTriggerEvent = niceSkill.screenPopTriggerEvent;
            }
            else
            {
                this.screenPopTriggerEvent = null;
            }
            this.useCustomScreenPops = niceSkill.useCustomScreenPops;
            this.screenPopDetail = niceSkill.screenPopDetail;
            this.minWorkingTime = niceSkill.minWorkingTime;
            this.agentless = niceSkill.agentless;
            this.agentlessPorts = niceSkill.agentlessPorts;
            this.initialPriority = +niceSkill.initialPriority;
            this.acceleration = +niceSkill.acceleration;
            this.maxPriority = +niceSkill.maxPriority;
            this.serviceLevelThreshold = niceSkill.serviceLevelThreshold;
            this.serviceLevelGoal = niceSkill.serviceLevelGoal;
            this.enableShortAbandon = niceSkill.enableShortAbandon;
            this.shortAbandonThreshold = niceSkill.shortAbandonThreshold;
            this.countShortAbandons = niceSkill.countShortAbandons;
            this.countOtherAbandons = niceSkill.countOtherAbandons;
            this.messageTemplateId = niceSkill.messageTemplateId;
            this.smsTransportCodeId = niceSkill.smsTransportCodeId;
            this.smsTransportCode = niceSkill.smsTransportCode;
            this.dispositions = niceSkill.dispositions || [];
            this.deliverMultipleNumbersSerially = niceSkill.deliverMultipleNumbersSerially;
            this.cradleToGrave = niceSkill.cradleToGrave;
            this.priorityInterrupt = niceSkill.priorityInterrupt;
            this.mediaTypeIcon = this.getSkillIcon();
            this.customMediaTypeName = this.setCustomMediaTypeName();
            this.requireManualAccept = niceSkill.requireManualAccept;
            this.presentAcceptReject = niceSkill.presentAcceptReject;
            this.agentResponseEnabled = niceSkill.agentResponseEnabled;
            this.agentFirstResponseTime = niceSkill.agentFirstResponseTime;
            this.agentFollowOnResponseTime = niceSkill.agentFollowOnResponseTime;
            this.customerResponseEnabled = niceSkill.customerResponseEnabled;
            this.customerIdleTime = niceSkill.customerIdleTime;
            this.timeExtensionEnabled = niceSkill.timeExtensionEnabled;
            this.evaluationCriteria = niceSkill.evaluationCriteria;
            this.focusMetric = niceSkill.focusMetric;
            this.equityLevel = niceSkill.equityLevel;
            this.focusLock = niceSkill.focusLock;
            this.fallbackTime = niceSkill.fallbackTime;
            this.agentlessDeliveryDelaySeconds = niceSkill.agentlessDeliveryDelaySeconds;

        }
    }

    private setCustomMediaTypeName(): string {
        switch (this.mediaTypeId) {
            // Email
            case 1:
                if (this.isOutbound)
                {
                    return 'Email Outbound';
                }
                return 'Email Outbound';
            // FAX
            case 2:
                return 'FAX';
            // Chat
            case 3:
                return 'Chat';
            // Phone
            case 4:
                if (this.isOutbound)
                {
                    if (this.outboundStrategy === 'Personal Connection') {
                        if (this.agentless) {
                            return 'Phone Dialer Blaster';
                        }
                        return 'Phone Dialer';
                    }
                    return 'Phone Outbound';
                }
                return 'Phone Inbound';
            // Voicemail
            case 5:
                return 'Voicemail';
            // Work Item
            case 6:
                return 'Work Item';
            // SMS
            case 7:
                return 'SMS';
            // Social
            case 8:
                return 'Social';
            // Digital
            case 9:
                return 'Digital';
        }
    }
    getSkillIcon(): string {
        switch (this.mediaTypeId) {
            // Email
            case 1:
                return 'email';
            // FAX
            case 2:
                return 'email';
            // Chat
            case 3:
                return 'chat';
            // Phone
            case 4:
                if (this.isOutbound)
                {
                    if (this.outboundStrategy === 'Personal Connection') {
                        return 'flash_on';
                    }
                    return 'phone_forwarded';

                }
                return 'phone_callback';
            // Voicemail
            case 5:
                return 'voicemail';
            // Work Item
            case 6:
                return 'confirmation_number';
            // SMS
            case 7:
                return 'chat';
            // Social
            case 8:
                return 'social';
            // Digital
            case 9:
                return 'forum';
        }
    }
}

